// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
//= require ./_namespace
//= require_tree .
// MAGIC_DESPROCKET_START
require('sprocket-compat?this!javascripts/components/_namespace.coffee')
require('sprocket-compat?this!javascripts/components/application/user/ProfilePreviewAffiliation.js.jsx')
require('sprocket-compat?this!javascripts/components/basic/avatar.js.jsx')
require('sprocket-compat?this!javascripts/components/buttons/close.js.jsx')
require('sprocket-compat?this!javascripts/components/buttons/delete.js.jsx')
require('sprocket-compat?this!javascripts/components/compound/checkbox_label.js.jsx')
require('sprocket-compat?this!javascripts/components/compound/image_header_subtext.js.jsx')
require('javascripts/components/modals/header_body_close.js.jsx')
require('javascripts/components/toasts/auto_bookmark_toast.js.jsx')
require('javascripts/components/toasts/basic_toast.js.jsx')
require('javascripts/components/toasts/link_toast.js.jsx')
require('javascripts/components/toasts/toast_base.js.jsx')
require('javascripts/components/users/user_affiliation.js.jsx')
require('javascripts/components/users/user_photo.js.jsx')
require('javascripts/components/utils.js')
// MAGIC_DESPROCKET_END
